import classNames from 'classnames'
import React, { Suspense, lazy } from 'react'
import { AsyncIconComponentsMap } from '../../generated/enums/icon-enum'
import styles from './Icon.module.scss'
import type { IconProps } from './types'
import { IconSize } from './types'

const Icon: React.FC<IconProps> = ({ size = IconSize.medium, ...props }) => {
  if (props.name) {
    const Component = lazy(AsyncIconComponentsMap[props.name])

    return (
      <Suspense
        fallback={<div className={classNames(styles['pintxo-icon'], props.className)} data-size={size} />}
      >
        <Component {...props} />
      </Suspense>
    )
  }

  return (
    <div className={classNames(styles['pintxo-icon'], props.className)} data-size={size}>
      <img {...props} />
    </div>
  )
}

export default Icon
